import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import { validateField } from '../../utils/validation/validation';
import InputField from '../../utils/InputField';
import TextAreaField from '../../utils/TextAreaField';
import Dropzone from "../../utils/dropzone";
import GoogleMapsWrapper from '../../utils/GoogleMapsWrapper';
import PlaceComponent from '../Address/AddressAutoPop';
import { formatPhoneNumber } from '../../utils/phoneFormatter';

function ApplicantForm({ data, onChange, onValidate, errors, isFrom = 'page' }) {
    
    const handleChange = (field, value) => {
        let processedValue = value;
        
        // Format phone number
        if (field === 'phoneNumber') {
            processedValue = formatPhoneNumber(value);
        }
        
        onChange(field, processedValue);
        const error = validateField(field, processedValue);
        onValidate(field, error);
    };

    const handleFileUpload = (fieldName, uploadedFiles) => {
        console.log('Files uploaded to field:', fieldName, uploadedFiles);
        onChange(fieldName, uploadedFiles); 
    };

    const [selectedOption, setSelectedOption] = useState('uploadPDF');

    const handleOptionChange = (e) => {
        setSelectedOption(e.target.value);
    };


    return (
        <Form>
            <Container className="px-0" fluid>
                <Row className="no-gutters">
                    <Col sm={isFrom === 'page' ? 8 : 12 }>
                        <div className={isFrom === 'page' ? 'form-wrapper rounded' : 'form-wrapper' }>
                            <div className="form-heading mb-4 text-uppercase fw-bold">Plan Review Information</div>
                            <Row className="mb-3">
                                <GoogleMapsWrapper>
                                    <PlaceComponent
                                        field="address"
                                        label="Project Address"
                                        className="mb-3"
                                        value={data.address}
                                        onChange={handleChange}
                                        type="text"
                                        error={errors.address}
                                    />
                                </GoogleMapsWrapper>    
                           </Row>
                           <Row className="mb-3">
                                <InputField
                                    field="planReviewType"
                                    label="Project Type"
                                    value={data.planReviewType}
                                    onChange={handleChange}
                                    error={errors.planReviewType}
                                    type="select"
                                    options={[
                                        "Commercial Remodel",
                                        "New Commercial Construction",
                                        "Residential Remodel",
                                        "New Residential Construction"
                                    ]}
                                    as={Col}
                                />
                            </Row>
                            <Row className="mb-3">
                                <InputField
                                    field="name"
                                    label="Applicant Name"
                                    value={data.name}
                                    onChange={handleChange}
                                    error={errors.name}
                                    type="text"
                                    as={Col}
                                />
                            </Row>
                           <Row className="mb-3">
                                <InputField
                                    field="email"
                                    label="Applicant Email Address"
                                    value={data.email}
                                    onChange={handleChange}
                                    error={errors.email}
                                    type="email"
                                    className="mb-3"
                                    as={Col}
                                />
                           </Row>
                            <Row className="mb-3">
                                <InputField
                                    field="phoneNumber"
                                    label="Applicant Phone Number"
                                    className="mb-3"
                                    value={data.phoneNumber}
                                    onChange={handleChange}
                                    pattern="^[0-9-]*$"
                                    error={errors.phoneNumber}
                                    type="text"
                                    as={Col}
                                /> 
                           </Row>
                           <Row className="mb-3">
                                <InputField
                                    field="communityEmailAddress"
                                    label="Community Email Address"
                                    value={data.communityEmailAddress}
                                    onChange={handleChange}
                                    error={errors.communityEmailAddress}
                                    type="email"
                                    className="mb-3"
                                    as={Col}
                                />
                           </Row>
                            
                        </div>
                    </Col>
                    <Col sm={isFrom === 'page' ? 4 : 12 }>
                        <div className="{isFrom === 'page' ? 'form-wrapper rounded' : 'form-wrapper' }">
                            <TextAreaField
                                field="comments"
                                label="Comment Area"
                                value={data.comments}
                                onChange={handleChange}
                                error={errors.comments}
                                placeholder=""
                                type="text"
                                as={Col}
                            />
                            <div className="form-heading mt-5 text-uppercase fw-bold">
                                Upload Files<span className="text-danger">*</span>
                            </div>
                            <div className='mt-3'>
                                <label>
                                    <input
                                        field="files"
                                        type="radio"
                                        value="uploadPDF"
                                        className='radio-mr'
                                        checked={selectedOption === 'uploadPDF'}
                                        onChange={handleOptionChange}
                                    />
                                    Upload PDF
                                </label>
                                <label>
                                    <input
                                        field="fileLink"
                                        type="radio"
                                        value="pdfUrl"
                                        className='radio-mrl'
                                        checked={selectedOption === 'pdfUrl'}
                                        onChange={handleOptionChange}
                                    />
                                    Paste Your PDF URL
                                </label>
                            </div>
                            <div>
                            {selectedOption === 'uploadPDF' && (
                                <div>
                                    <Dropzone fileTypes={['application/pdf']} showPreview={true} fieldName="files" onFileUpload={handleFileUpload} maxFileSizeMB={250} />
                                </div>
                            )}
                            {selectedOption === 'pdfUrl' && (
                                <div className='my-3'>
                                    <Row className="mb-3">
                                        <InputField
                                            field="pdfUrl"
                                            label="Paste Your PDF URL"
                                            value={data.pdfUrl}
                                            onChange={handleChange}
                                            as={Col}
                                        />
                                    </Row>
                                    <div className="my-2">
                                        Please enter a valid PDF URL with https:// or http:// .
                                    </div>
                                </div>
                            )}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Form>
    );
}

export default ApplicantForm;